import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
	static targets = ["dialog"];
	static values = {
		autoOpen: Boolean,
	};

	connect() {
		this.onClose = this.onClose.bind(this);
		this.dialogTarget.addEventListener("close", this.onClose);

		if (this.autoOpenValue) this.dialogTarget.showModal();
	}

	disconnect() {
		clearTimeout(this.removeTimer);
		this.dialogTarget.removeEventListener("close", this.onClose);
	}

	open(e) {
		e.preventDefault();
		this.dialogTarget.showModal();
	}

	close() {
		this.dialogTarget.close();
	}

	// Срабатывает при любом закрытии: крестик, бэкдроп и Esc.
	// Удаляем сам диалог (а не чистим #modal), чтобы при быстром
	// переоткрытии не затереть уже загруженную новую модалку.
	onClose() {
		this.removeTimer = setTimeout(() => this.element.remove(), 300);
	}
}
